import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ToggleButton from "react-toggle-button";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleDDL from "../../../modules/SimpleDDL";
import Api from "../../../Services/Api";
import {HttpStatus, Status} from "../../common/Constants";
import {
    removeNullFields,
    flattenFormGroupObject,
    getValueFromDDL,
    mapToObjectDDL,
} from "../../common/mapper";
import {formGroup} from "./config";
import MasterLeasingFilter from "./masterLeasingFilter";
import MasterLeasingModifying from "./masterLeasingModifying";
import ErrorAction from "../../../Redux/ErrorRedux";
import {fetchDataAsync} from "../../../Services/Utils";
import {connect} from "react-redux";

class MasterLeasing extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;
                    return <>{rowNumber}</>;
                },
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        },
        {
            name: "leasingId",
            label: "ID",
        },
        {
            name: "leasingName",
            label: "Nama Leasing",
        },
        {
            name: "dataProvince.provinceName",
            label: "Provinsi",
        },
        {
            name: "dataKecamatan.kecamatanName",
            label: "Kecamatan",
        },
        {
            name: "dataKabkot.kabKotName",
            label: "Kota",
        },
        {
            name: "dataKelurahan.zipcode",
            label: "Kode Pos",
        },
        {
            name: "leasingId",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    const status = this.state.dataTable[rowIndex].status;
                    return (
                        <FlexView
                            vAlignContent="center"
                            style={{justifyContent: "space-between"}}
                        >
                            <ToggleButton
                                value={R.equals(status, Status.ACTIVE)}
                                onToggle={(value) =>
                                    this.handleUpdateStatus(
                                        val,
                                        !value ? Status.ACTIVE : Status.INACTIVE
                                    )
                                }
                            />
                            <SimpleButton
                                category="action_button"
                                className="btnAct"
                                onClick={() => this.handleModifyingVisibility(val)}
                                icon={
                                    <i
                                        className="fa fa-lw fa-pencil-alt"
                                        style={{
                                            backgroundColor: "transparent",
                                            color: "red",
                                            fontSize: 20,
                                        }}
                                    />
                                }
                            />
                            <SimpleButton
                                category="action_button"
                                className="btnAct margin-left-15px"
                                onClick={() => this.handleShowAlert(val)}
                                icon={
                                    <i
                                        className="fa fa-trash"
                                        style={{
                                            backgroundColor: "transparent",
                                            color: "red",
                                            fontSize: 20,
                                        }}
                                    />
                                }
                            />
                        </FlexView>
                    );
                },
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            deleteId: "",
            alertVisible: false,
            printVisible: false,
            filterVisible: false,
            modifyingVisible: false,
            selectedData: null,
            loading: false,
            listKodeCabang: [],
            lastCabang: null,
            filterData: {},
            submittedFilterData: {},
            isFetch: false,
            pagination: {
                totalData: 1,
                limit: 5,
                page: 1,
            },
            kotaOptions: [],
            kecamatanOptions: [],
            kelurahanOptions: [],
            cabangOptions: [],
            dataTable: [],
            alertCannotDelete: false,
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        try {
            const response = await Api.create(
                "NAGAMAS_MASTER_DATA"
            ).findAllMasterCabang();
            let filteredData = [];

            if (response.ok && !R.isEmpty(response.data.data)) {
                const cabangs = response.data.data;
                const allowedCabangs = this.props.menuAccess.map(
                    (data) => data.idRefObj
                );

                filteredData = cabangs
                    .filter((item) => allowedCabangs.includes(item.kodeCabang))
                    .map((c) => mapToObjectDDL(c.namaDealer, c.kodeCabang));

                const defaultCabang = filteredData.length > 0 ? [filteredData[0]] : [];

                await this.setState((prevValue) => ({
                    ...prevValue,
                    cabangOptions: filteredData,
                    listKodeCabang: defaultCabang,
                    lastCabang: defaultCabang,
                }));

                await this.fetchData({
                    listKodeCabang: defaultCabang.map((c) => c.value),
                });
            }
        } catch (error) {
            console.error("Error:", error);
        }

        this.handleTriggerLoading();
    };

    componentDidUpdate = async (_, prevState) => {
        if (
            (prevState.pagination.page !== this.state.pagination.page ||
                prevState.pagination.limit !== this.state.pagination.limit) &&
            !this.state.isFetch
        ) {
            this.handleTriggerLoading();
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
            this.handleTriggerLoading();
        }
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    refetch = async () => {
        await this.fetchData(
            this.state.submittedFilterData,
            this.state.pagination.page,
            this.state.pagination.limit
        )
    };

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevValue) => ({
            ...prevValue,
            isFetch: true,
            pagination: {...prevValue.pagination, totalData: 0},
        }));
        let {lastCabang} = this.state;
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterLeasing,
            menuName: "Master Leasing",
            setError: this.props.setError,
            args: {
                paramFilters: {
                    ...filter,
                    listKodeCabang: !R.isNil(filter?.listKodeCabang) ? filter.listKodeCabang : lastCabang.map(i => i.value),
                },
                page,
                limit,
            },
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: response.data.data,
                pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.totalData,
                    page,
                    limit,
                },
            }));
        }
        this.setState((prevValue) => ({...prevValue, isFetch: false}));
    };

    handleSubmitFilter = async () => {
        let {filterData, lastCabang} = this.state;
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            listKodeCabang: R.isNil(filterData?.listKodeCabang) ? lastCabang : [],
        }));
        const request = removeNullFields({
            ...filterData,
            provinceId: getValueFromDDL(filterData, "provinceId"),
            kabkotId: getValueFromDDL(filterData, "kabkotId"),
            kecamatanId: getValueFromDDL(filterData, "kecamatanId"),
            zipCode: getValueFromDDL(filterData, "zipCode"),
            listKodeCabang: !R.isNil(filterData.listKodeCabang)
                ? filterData.listKodeCabang.map((kc) => kc.value)
                : [],
            status: getValueFromDDL(filterData, "status"),
        });
        await this.fetchData(request, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
            filterVisible: false,
            submittedFilterData: request,
        }));
    };

    handleModalVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleUpdateStatus = async (id, status) => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const request = {
            leasingId: id,
            status,
        };
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateMasterLeasingStatus,
            menuName: "Master Leasing",
            setError: this.props.setError,
            args: request
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.refetch();
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    handlePrint = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            printVisible: !prevValue.printVisible,
        }));
    };

    handleShowAlert = (id) => {
        if (id) {
            this.setState((prevValue) => ({
                ...prevValue,
                deleteId: id,
                alertVisible: true,
            }));
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                deleteId: "",
                alertVisible: false,
                loading: false,
            }));
        }
    };

    handleShowAlertCannotDelete = () => {
        this.setState((prevValue) => ({...prevValue, alertCannotDelete: !prevValue.alertCannotDelete}));
    };

    handleSubmitDelete = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        let res = await Api.create("NAGAMAS_MASTER_DATA").deleteMasterLeasing(
            this.state.deleteId
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.refetch();
        } else if (res.data.code === 509) {
            this.handleShowAlertCannotDelete();
        }
        this.handleShowAlert();
    };

    handleModifyingVisibility = async (id) => {
        if (id) {
            const response = await Api.create(
                "NAGAMAS_MASTER_DATA"
            ).getMasterLeasingById(id);
            if (response.ok && !R.isNil(response.data.data)) {
                const data = response.data.data;
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: {
                        ...data,
                        listKodeCabang: data.listKodeCabang.map((lkc) =>
                            mapToObjectDDL(
                                lkc.dataCabang.namaDealer,
                                lkc.dataCabang.kodeCabang
                            )
                        ),
                        provinceId: mapToObjectDDL(
                            data.dataProvince.provinceName,
                            data.dataProvince.id
                        ),
                        kabkotId: mapToObjectDDL(
                            data.dataKabkot.kabKotName,
                            data.dataKabkot.kabKotId
                        ),
                        kecamatanId: mapToObjectDDL(
                            data.dataKecamatan.kecamatanName,
                            data.dataKecamatan.id
                        ),
                        zipCode: mapToObjectDDL(
                            data.dataKelurahan.zipcode,
                            data.dataKelurahan.zipcode
                        ),
                        groupLeasing: data.groupLeasing? mapToObjectDDL(
                            data?.groupLeasing?.value,
                            data?.groupLeasing?.key
                        ) : null,
                        kelurahanId: data.dataKelurahan.id,
                    },
                    modifyingVisible: !prevValue.modifyingVisible,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }
    };

    handleSubmitModifying = async (controls) => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const formGroup = flattenFormGroupObject(controls);
        const request = {
            ...formGroup,
            listKodeCabang: !R.isEmpty(formGroup.listKodeCabang)
                ? formGroup.listKodeCabang.map((lkc) => ({kodeCabang: lkc.value}))
                : [],
            provinceId: getValueFromDDL(formGroup, "provinceId"),
            kabkotId: getValueFromDDL(formGroup, "kabkotId"),
            kecamatanId: getValueFromDDL(formGroup, "kecamatanId"),
            zipCode: getValueFromDDL(formGroup, "zipCode"),
            groupLeasing: getValueFromDDL(formGroup, "groupLeasing"),
            kelurahanId: formGroup.zipCode.kelurahanId || formGroup.kelurahanId,
        };

        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").modifyMasterLeasing,
            menuName: "Master Leasing",
            setError: this.props.setError,
            args: request,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.refetch();
            this.handleModifyingVisibility();
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleCabangChange = async (value) => {
        const selectedCabang = value ? [value] : [];
        await this.setState((prevValue) => ({
            ...prevValue,
            listKodeCabang: selectedCabang,
            lastCabang: selectedCabang,
        }));

        this.handleTriggerLoading();
        try {
            await this.fetchData({
                listKodeCabang: selectedCabang.map((c) => c.value),
            });
        } catch (error) {
            console.error("Error during fetchData:", error);
        }
        this.handleTriggerLoading();
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView
                        style={{justifyContent: "space-between", alignItems: "center"}}
                        className="margin-bottom-20px margin-top-5px"
                    >
                        <FlexView vAlignContent="center">
                            <SimpleDDL
                                id="select_options_nama_cabang_hak_akses"
                                placeholder="Nama Cabang Hak Akses"
                                name="listKodeCabang"
                                box="search"
                                containerclassname="margin-bottom-5px width width-250px"
                                options={this.state.cabangOptions}
                                value={this.state.listKodeCabang[0] || null}
                                onChange={this.handleCabangChange}
                            />
                        </FlexView>
                        <SimpleButton
                            className="btn background-red"
                            category="action_button"
                            onClick={this.handleModalVisibility}
                            icon={<i className="fa fa-qrcode"></i>}
                        />
                    </FlexView>
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.tableColumns}
                        toCount={this.state.pagination.totalData}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                        options={defaultTableChange(
                            this.handleChangePage,
                            this.handleRowsPerPage
                        )}
                        footerAdditionalButtons={
                            <>
                                <SimpleButton
                                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                                    onClick={() => this.handleModifyingVisibility()}
                                >
                                    Tambah
                                </SimpleButton>
                                <SimpleButton secondary onClick={this.handlePrint}>
                                    Cetak
                                </SimpleButton>
                            </>
                        }
                    />
                </Container>
                {this.state.filterVisible && (
                    <MasterLeasingFilter
                        state={this.state}
                        onClickClose={() => this.handleModalVisibility()}
                        onSetState={this.handleStateChange}
                        onSubmit={this.handleSubmitFilter}
                    />
                )}
                {this.state.loading && (
                    <SimpleLoadingOverlay active={this.state.loading}/>
                )}
                {this.state.printVisible && (
                    <SimplePrintTable onClearPrint={this.handlePrint}/>
                )}
                {this.state.alertVisible && (
                    <SimpleAlert
                        visible={this.state.alertVisible}
                        onClickClose={() => this.handleShowAlert()}
                        content={"Apakah anda yakin ingin menghapus data leasing ?"}
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton secondary onClick={() => this.handleShowAlert()}>
                                    Batal
                                </SimpleButton>
                                <SimpleButton onClick={() => this.handleSubmitDelete()}>
                                    Iya
                                </SimpleButton>
                            </FlexView>
                        }
                    />
                )}
                {this.state.modifyingVisible && (
                    <MasterLeasingModifying
                        formGroup={formGroup}
                        initialValues={this.state.selectedData}
                        state={this.state}
                        onClickClose={() => this.handleModifyingVisibility()}
                        onSubmit={this.handleSubmitModifying}
                    />
                )}

                {this.state.alertCannotDelete && (
                  <SimpleAlert
                    visible={this.state.alertCannotDelete}
                    onClickClose={() => this.handleShowAlertCannotDelete()}
                    content={
                        <div>
                            <p>Data tidak dapat dihapus, sudah masuk kedalam transaksi.</p>
                        </div>
                    }
                    additionalButtons={
                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                            <SimpleButton onClick={() => this.handleShowAlertCannotDelete()}>
                                OK
                            </SimpleButton>
                        </FlexView>
                    }/>
                )}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterLeasing);
